<template>
  <div id="document">
    <Header></Header>
    <Navi currentPage="result"></Navi>
    <div class="main_doc" id="main">
        <div class='show_iterm'>  
            <div class='show_iterm_title'>Check your results</div> 
            <div class="tips" v-if="!error_id">
                The webpage tracks the progress and results of your job, please mark the URL for checking it at anytime. The job will run about several minutes. The webpage will refresh automatically until the job is completed. The results page will be kept for 30 days after the job is completed.
            </div>
            <div class="results_msg"><p v-html="info"></p></div>
        </div>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import Header from '@/components/header.vue'
import Navi from '@/components/navigate.vue'
import Footer from '@/components/footer.vue'
import Doc from '@/components/doc.vue'

import {api_dir,getTime} from '@/bus.js'
import axios from 'axios/dist/axios.min';

// import EleDoc from '@/components/eledoc.vue'
export default {
    name: 'online',
    components: {Navi,Footer,Doc,Header},
    data:function(){
        return {
            task_id:'',
            finish:false,
            info:'',
            error_id:true,
            now_time:''
        }
    },
    created:function(){
        this.getTaskID();
    },
    mounted: function () {
        var _this = this;
        _this.loadData();
        this.timer = setInterval(function () {
            if (_this.progress_num == 5) {
                clearInterval(_this.timer);
            } else {
                _this.loadData();
            }
        }, 8000);

    },
    destroyed() {
        clearInterval(this.timer)
    },

    methods: {
        getTaskID() {
            if ('task_id' in this.$route.query) {
                this.task_id = this.$route.query.task_id;
            } else {
                this.task_id =''
            }
        },
        loadData() {
            var _this = this
            axios
                .get(api_dir + "/gec_api.php?action=check_task", {
                    params: { 'task_id': _this.task_id },
                })
                .then(function (response) {
                    _this.now_time='Last check: '+getTime(Date.parse(new Date())/1000)
                    var res = JSON.parse(JSON.stringify(response.data));
                    if (res.error_code == 0) {
                        var status=res.data.status
                        _this.finish=false
                        _this.error_id=false
                        var info=''
                        if(status==1){
                            info='The task ('+_this.task_id+') is submitting to task queue! Please wait patiently! (' +_this.now_time+')'
                        }else if(status==2){
                            info='The task ('+_this.task_id+') is running! (' +_this.now_time+')'
                        }else if(status==3){
                            info='The task ('+_this.task_id+') is running unsuccessfully, please check your GWAS summary file and network. If you have any question, please contact us by e-mail:\
                      <a style="color:#316652" href="mailto:xuech_sysu@163.com">xuech_sysu@163.com</a> with attaching your task ID!'+'<br><br>Error message: '+ res.data['status_msg']
                        }else if(status==4){
                            console.log(status)
                            info='<p>The task ('+_this.task_id+') has been completed.</p> '+_this.printResults(res.data['result_info'],res.data['result_url'])
                            _this.finish=true
                        }
                        _this.info=info
                    } else {
                        _this.info = "No such task_id: " + _this.task_id + ". Please check!";
                        _this.finish=true
                        _this.error_id=true
                    }
                })
                .catch(function (error) {
                    console.log(error);
                })
        },
     printResults:function(log,url){
        var info='<p><span style="font-weight: bold">Result Summary:</span> '+log+' (see details in <a style="color:#316652" href="https://pmglab.top/gec/'+url+'">here</a>)</p>'
       return(info)
    },
    }
}
</script>

<style scoped>
.main_doc{
    width: 960px;
    border: solid #E1EAEA 1px;
    position: relative;
  top:85px;
  bottom: 10px;
  left: 205px;
  /* height: 600px; */
  margin-left: 15px;
  margin-top: 10px;
  padding-bottom: 10px;
  min-height: 300px;
}

.tips{
    vertical-align:middle;
	display: inline-block;
	width:90%;
	text-align: left;
    margin: 5px 20px;
    font-size: 15px;
    line-height: 20px;
    padding: 10px;
    background: #FDF6EC;
}
.results_msg{
    vertical-align:middle;
	display: inline-block;
	width:90%;
	text-align: left;
    margin: 5px 20px;
    font-size: 16px;
    line-height: 20px;
    padding: 10px;
}
.input_zone{
    /* display: inline; */
    height: 530px;
    width: 100%;
    margin: 0 auto;
}

.show_iterm_title{
    text-align: left;
    font-weight: bold;
    margin-top: 20px;
    margin-bottom: 20px;
    padding-left: 10px;
    font-size: 18px;
    color: #006652;
}

.show_iterm_text{
    text-align: left;
    font-size: 13px;
    margin-top:5px ;
}
.search,.show_iterm {
    /* display: inline; */
    /* float: left; */
    margin: 20px 25px;
    /* width: 560px; */
}

</style>


// WEBPACK FOOTER //
// src/views/result.vue